<template>
  <div class="index-wrap">
    <div class="index-container">
      <a href="/#/home" class="zlh-ch" @click="langSet('cn')"></a>
      <a href="/#/home" class="zlh-en" @click="langSet('en')"></a>
      <a href="http://www.bceia.org.cn/" class="enter-ch" target="_blank"></a>
      <a href="http://www.bceia.org.cn/index.php" class="enter-en" target="_blank"></a>
    </div>
    <div class="index-copyright">
      <a href="https://beian.miit.gov.cn/#/Integrated/index"
        >京ICP备05039987号-3</a
      ><a> </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: "北京分析测试学术报告会暨展览会",
      meta: [
        {
          name: "description",
          content: "北京分析测试学术报告会暨展览会",
        },
        {
          name: "keywords",
          content: "分析展",
        },
      ],
    };
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    langSet(type){
      localStorage.setItem("languageSet", type);
      setTimeout(()=>{
        location.reload();
      }, 100)
    }
  },
};
</script>

<style lang="scss" scoped>
.index-wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  background: url("../../assets/home.jpg") no-repeat center;
  background-size: 102%;
  .index-container {
    width: 100%;
    position: absolute;
    top: 80%;
    left: 0;
    overflow: hidden;
    text-align: center;
    a {
      display: inline-block;
      width: 9%;
      height: 46px;
      margin: 0 2%;
    }
    .zlh-ch {
      background: url("../../assets/home_btn1.png") no-repeat;
      background-size: contain;
    }
    .zlh-en {
      background: url("../../assets/home_btn2.png") no-repeat;
      background-size: contain;
    }
    .enter-ch {
      background: url("../../assets/home_btn3.png") no-repeat;
      background-size: contain;
    }
    .enter-en {
      margin-right: 0;
      background: url("../../assets/home_btn4.png") no-repeat;
      background-size: contain;
    }
  }
  .index-copyright {
    position: absolute;
    left: 0;
    right: 10px;
    text-align: right;
    margin: auto;
    bottom: 2%;
    a{
      color: #0000EE;
    }
  }
}
</style>